import React, {useEffect, useState} from 'react';
import DisposeTableItem from "../../../base/dispose-tab-item";
import {useBookingRuleTemplate} from "../../../../../hooks/product-price/booking-rule-template";
import {useCancelRuleTemplate} from "../../../../../hooks/product-price/cancel-rule-template";
import {useServicePolicyTemplate} from "../../../../../hooks/product-price/service-policy-template";

interface IComponentProps { 
  data?: any;
}
const SaleRuleItem: React.FC<IComponentProps> = (props) => {
  const data = props.data;
  const [ dataList, setDataList ] = useState<any[]>([])
  const { tableActionView: bookingTableAction  } = useBookingRuleTemplate();
  const { tableActionView:  cancelTableAction } = useCancelRuleTemplate();
  const { tableActionView:  servicePolicyTableAction } = useServicePolicyTemplate();
  useEffect(() => {

    const { cancel_rule_name, pre_booking_rule_name, serve_rule_name, cancel_rule_code, pre_booking_rule_code, serve_rule_code  } = data
    const list = [
      {
        text: pre_booking_rule_name,
        clickAction: () => {
          bookingTableAction({
            rule_code: pre_booking_rule_code,
          })
        }
      },
      {
        text: cancel_rule_name,
        clickAction: () => {
          cancelTableAction({
            rule_code: cancel_rule_code,
          })
        }
      },
      {
        text: serve_rule_name,
        clickAction: () => {
          servicePolicyTableAction({
            rule_code: serve_rule_code,
          })
        }
      },
    ]
    setDataList(list)
  }, [data]);

  return (
    <>
      <DisposeTableItem dataList={dataList}></DisposeTableItem>
    </>
  );
};

export default SaleRuleItem;
